<template>
  <div>
    <section class="mt-3 container progress-page">
      <stars-bar :data="getStarsData" :showParentStar="true"></stars-bar>
      <div class="d-flex justify-content-center aling-items-center">
        <p class="mr-2">Points per Skill</p>
        <question-popup
          v-if="parentPopups['points_per_skill']"
          popoverKey="points-skill"
          :title="parentPopups['points_per_skill']['title']"
          :description="parentPopups['points_per_skill']['information']"
        />
      </div>
      <bar-chart
        :series="skillSeries"
        :categories="skillCategories"
        title=""
        yTitle="Skill"
        xTitle="Points"
        :height="450"
        :horizontal="true"
      />
      <date-selector
        :setValue="(value) => (calendarValue = value)"
        :weekly="weekly"
        :dateDisabled="dateDisabled"
      />
      <div class="dateSelector-Menu">
        <label>Time Format</label>
        <b-select v-model="weekly" class="w-25">
          <option :value="false">Daily</option>
          <option :value="true">Weekly</option>
        </b-select>
      </div>
      <div class="d-flex justify-content-center aling-items-center">
        <p class="mr-2">% of Points earned per day</p>
        <question-popup
          v-if="parentPopups['points_per_day']"
          popoverKey="points-eraned-skill"
          :title="parentPopups['points_per_day']['title']"
          :description="parentPopups['points_per_day']['information']"
        />
      </div>
      <bar-chart
        :series="pointsDaySeries"
        :categories="pointsDayCategories"
        title=""
        yTitle="Percentage"
        xTitle="Dates"
        :height="450"
        :customOptions="customOptions"
        class="mt-4"
      />
    </section>
  </div>
</template>
<script>
import barChart from '@/components/apexCharts/BarChart.vue';
import dateSelector from './dateSelector/dateSelector.vue';
import { mapActions, mapGetters } from 'vuex';
import StarsBar from '../general/starsBar/starsBar.vue';
import QuestionPopup from '../general/QuestionPopup.vue';

export default {
  components: {
    barChart,
    dateSelector,
    StarsBar,
    QuestionPopup,
  },
  data() {
    return {
      weekly: false,
      calendarValue: '',
      categoriesSum: [],
      valuesSum: [],
      categoriesMean: [],
      valuesMean: [],
      parentAvailablePoints: 0,
      parentTotalPoints: 0,
      customOptions: {
        tooltip: {
          y: {
            formatter: function(val) {
              return Math.abs(val) + '%';
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          title: {
            text: 'Percentage',
          },
          labels: {
            formatter: function(val) {
              return Math.abs(Math.round(val)) + '%';
            },
          },
        },
      },
    };
  },
  watch: {
    weekly: function() {
      this.FetchParentPointsPerTime({
        parentId: this.getUserId,
        weekly: this.weekly,
        startDate: this.calendarValue,
      });
    },
    calendarValue: function() {
      this.FetchParentPointsPerTime({
        parentId: this.getUserId,
        weekly: this.weekly,
        startDate: this.calendarValue,
      });
    },
  },
  methods: {
    ...mapActions('progress', ['FetchParentPointsPerTime']),
    ...mapActions('rewards', ['FetchParentRewards']),
    dateDisabled(ymd, date) {
      let weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate());
      return date > weekAgo;
    },
    transformDate(date) {
      let offset = new Date().getTimezoneOffset() / 60;
      if (offset < 10) {
        offset = '0' + offset;
      }
      if (date.search('T') == -1) {
        date += `T00:00:00-${offset}:00`;
      }
      let objDate = new Date(date);
      var mm = objDate.getMonth() + 1; // getMonth() is zero-based
      var dd = objDate.getDate();
      return (mm > 9 ? '' : '0') + mm + '/' + (dd > 9 ? '' : '0') + dd;
    },
    loadParentData() {
      this.FetchParentRewards(this.getUserId).then(() => {
        this.parentAvailablePoints = this.getUserObject.available_points;
        this.parentTotalPoints = this.getUserObject.total_points;
      });
    },
  },
  mounted() {
    this.loadParentData();
  },
  computed: {
    ...mapGetters('progress', ['getParentPointsBySkill', 'getParentPointsPerTime', 'parentPopups']),
    ...mapGetters('user', ['getUserId', 'getUserObject']),
    skillSeries() {
      return [
        {
          name: 'Points per Skill',
          data: this.getParentPointsBySkill.map((skill) => {
            return { x: skill.skill, y: skill.points };
          }),
        },
      ];
    },
    skillCategories() {
      let categories = [];
      this.getParentPointsBySkill.forEach((skill) => {
        categories.push(skill.skill);
      });
      return categories;
    },
    pointsDaySeries() {
      return [
        {
          name: 'Points earned per day',
          type: 'bar',
          data: this.getParentPointsPerTime.map((day) => {
            return { x: day.date, y: day.percentage };
          }),
        },
      ];
    },
    pointsDayCategories() {
      let categories = [];
      this.getParentPointsPerTime.forEach((skill) => {
        categories.push(skill.date);
      });
      return categories;
    },
    getStarsData() {
      return [
        { text: 'Available points', stars: this.parentAvailablePoints, display: true },
        { text: 'Total points', stars: this.parentTotalPoints, display: true },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  position: relative;
}

.dateSelector-Menu {
  display: flex;
  gap: 1em;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin: auto;

  & > label {
    margin: 0;
  }
}

.progress-page {
  .wrapper-question-popover {
    color: #1e90ff;
  }
}
</style>
